// extracted by mini-css-extract-plugin
export default {"pagination_list":"pagination_pagination_list__E7Hg5","selected":"pagination_selected__+NJ2F"};